module.exports = __webpack_public_path__ + "img/id_card_front.4e0eab08.png";